import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownTimer() {
  const [deadline] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    return date.getTime();
  });
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = deadline - new Date().getTime();
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [deadline]);
  const timeUnits = [{
    label: 'Days',
    value: timeLeft.days
  }, {
    label: 'Hours',
    value: timeLeft.hours
  }, {
    label: 'Minutes',
    value: timeLeft.minutes
  }, {
    label: 'Seconds',
    value: timeLeft.seconds
  }];
  return <div className="flex justify-center gap-2 sm:gap-3 md:gap-4" data-id="element-44">
      {timeUnits.map((unit, index) => <motion.div key={unit.label} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4,
      delay: index * 0.1
    }} className="flex flex-col items-center" data-id="element-45">
          <div className="bg-white text-navy rounded-lg p-2 sm:p-3 md:p-4 min-w-[50px] sm:min-w-[60px] md:min-w-[80px] shadow-lg" data-id="element-46">
            <div className="text-xl sm:text-2xl md:text-4xl font-bold tabular-nums" data-id="element-47">
              {String(unit.value).padStart(2, '0')}
            </div>
          </div>
          <div className="text-xs sm:text-xs md:text-sm text-white mt-1 sm:mt-2 font-medium" data-id="element-48">
            {unit.label}
          </div>
        </motion.div>)}
    </div>;
}